import { hbs } from 'ember-cli-htmlbars';
export default hbs("{{page-title (t \"loginPage.formTitle\")}}\n<Onboarding>\n  <LoginForm @config={{@model}} />\n</Onboarding>")